/**
 * @file Available feature flags for the Admin interface.
 *
 * Make sure to update `feature-flags-categories.js` with the corresponding flag description
 * whenever a new flag is added.
 */

// application
export const FF_VERSION_MISMATCH = 'version-mismatch';
export const FF_FORETHOUGHT = 'forethought';
// account management
export const FF_SSO = 'single-sign-on';
export const FF_ACCOUNTS = 'accounts';
export const FF_SSO_RESET_PASSWORD = 'sso-reset-password';
// scheduling
export const FF_DRAFT_GAMES = 'draft-games';
export const FF_LEGACY_DRAFTS_DISABLED = 'legacy-drafts-disabled';
export const FF_TOURNAMENTS = 'tournaments';
export const FF_CUPS = 'cups';
export const FF_SCHEDULE_MENU = 'schedule-menu';
export const FF_BRACKETS = 'brackets';
export const FF_DRAFT_LIMIT_BYES = 'draft-limit-byes';
export const FF_DRAFT_DEFAULT_ROUNDS = 'draft-default-rounds';
export const FF_DRAFT_DEFAULT_SLOTS = 'draft-default-slots';
export const FF_SEQUENCES = 'sequences';
export const FF_SCHEDULE_TEAMS_ORDER = 'schedule-teams-order';
export const FF_SCHEDULE_TEAMS_DISABLE_ADD_SYNCED = 'schedule-teams-disable-add-synced'
export const FF_CROSS_SCHEDULING = 'cross-scheduling';
export const FF_TEAM_SHORT_NAMES = 'team-short-names';
export const FF_POOLS = 'pools';
export const FF_MANUAL_RANKINGS = 'manual-rankings';
export const FF_ASSOCIATION_SCHEDULER = 'association-scheduler';
export const FF_SEASON_CLICK_SCHEDULER = 'season-click-scheduler';
// officiating
export const FF_SCOREKEEPERS = 'scorekeepers';
export const FF_TIMEKEEPERS = 'timekeepers';
export const FF_OFFICIALS = 'officials';
export const FF_ADDITIONAL_LINESPERSONS = 'additional-linespersons'
export const FF_GRADES = 'grades';
export const FF_OFFICIAL_HIDE_ASSIGNERS = 'official-hide-assigners';
export const FF_DISABLE_ADD_QUALIFICATIONS = 'disable-add-qualifications'
export const FF_SID_MEMBER_TYPES = 'sid-member-types';
// scorekeeping
export const FF_SCOREKEEPING_APP = 'scorekeeping-app';
export const FF_PERIODS = 'periods';
export const FF_PENALTY_SERVED_BY = 'penalty-served-by';
export const FF_PENALTY_START_END = 'penalty-start-end';
export const FF_PENALTY_FILL_START = 'penalty-fill-start';
export const FF_DOUBLE_FORFEIT = 'double-forfeit';
export const FF_PHOTOS = 'photos';
export const FF_PRINT_LINEUP = 'print-lineup';
export const FF_BATTERS = 'batters';
export const FF_PITCHERS = 'pitchers';
export const FF_GOALIES = 'goalies';
export const FF_REQUIRE_LINEUPS = 'require-lineups';
export const FF_REQUIRE_GAME_START = 'require-game-start';
export const FF_REQUIRE_TEAMS = 'require-teams';
export const FF_APPROVAL_SIGNATURE = 'approval-signature';
export const FF_HIDE_INFRACTION_NAME = 'hide-infraction-name';
export const FF_SPORTSMANSHIP = 'sportsmanship';
export const FF_RESTRICT_LINEUP_ENTRY = 'restrict-lineup-entry'
// sanction management
export const FF_SUSPENSIONS_MENU = 'suspensions-menu';
// legacy public sites
export const FF_CMS = 'cms';
